import { render } from "./BrandStyriaITSolutions.vue?vue&type=template&id=55878b85"
import script from "./BrandStyriaITSolutions.vue?vue&type=script&lang=ts"
export * from "./BrandStyriaITSolutions.vue?vue&type=script&lang=ts"

import "./BrandStyriaITSolutions.vue?vue&type=style&index=0&id=55878b85&lang=scss"
script.render = render

export default script